// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__33S0J"};